import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import AmendmentReceipt from '../../modules/subject/components/AmendmentReceipt';

const AmendmentReceiptPage = ({ isGroup = false }: { isGroup?: boolean }) => {
  const { t } = useTranslation();
  const title = isGroup
    ? t('amendment->>GroupAmendmentReceipt.ThankYou')
    : t('amendment->>AmendmentReceiptPage.Thank you. You have successfully amended your subjects.');

  return (
    <>
      <TitleHeader state="success" title={title} />

      <ContentTemplate>
        <AmendmentReceipt isGroup={isGroup} />
      </ContentTemplate>
    </>
  );
};

export default AmendmentReceiptPage;
